import { Container } from "react-bootstrap";

const Ethics = () => {
   return ( 
<div className="px-6" style={{backgroundColor:'#DADDE4'}}>

<Container className="pt-5  ">
  <div className="Ourprivacy  rounded-3  mt-5"><h3 className="text-center p-3">Ethics</h3></div>
<h4 className="About-us pt-5 fs-4 fw-bold ">ETHICAL STANDARDS</h4>
<p className="text text-justify py-2 P-text">
<span className=" fw-bold">UR9 GROUP</span> is committed to conducting our business with honesty and 
integrity, and we expect all staff to maintain high standards.<br></br>
It is vital that we conduct our business at a level where our actions cannot be 
questioned. Accordingly, the Board of Directors has formulated and approved a 
<span className=" fw-bold">  Code of Ethics Statement</span> that describes our principles and values. <br></br><br></br>
Furthermore, the Board has approved a comprehensive <span className=" fw-bold">Anti-Corruption and 
Bribery Policy</span> which sets out our responsibilities, and also the responsibilities of 
those who work for us. We take a zero-tolerance approach to the making or 
receiving of bribes or corrupt payments in any form - and expect the same 
impeccable standards of all those with whom we do business. <br></br> <br></br>
We have added to our already-robust set of reporting systems by creating a 
whistleblowing policy</p>


<h4 className="About-us pt-2 fs-4 fw-bold ">CODE OF ETHICS - ANTI CORRUPTION AND BRIBERY</h4>
<p className="text text-justify py-2 P-text">
The <span className="fw-bold"> UR9 GROUP</span>  reputation is built on our values as a company, the values of 
our employees, and our collective commitment to acting at all times with 
integrity. <br></br><br></br>
We condemn corruption in all its forms: we will not tolerate it in our business -
and we expect the same of those with whom we do business. <br></br><br></br>
We take a zero-tolerance approach to the making or receiving of bribes or 
corrupt payments in any form and will uphold all laws relevant to countering 
bribery and corruption in all the jurisdictions in which we operate. <br></br> <br></br>
We have formulated a Code of Ethics Statement, approved by the <span className="fw-bold">UR9 Group  </span>
<span className="fw-bold"> Board of Directors</span> and signed by the <span className="fw-bold"> Chairman </span>  and the <span className="fw-bold"> Group Chief Executive</span>.
</p>



<h4 className="About-us pt-2 fs-4 fw-bold ">Code of Ethics Statement</h4>
<p className="text text-justify py-2 P-text">
<span className="fw-bold fs-6">UR9 GROUP</span > aspires to be a market leader in respect of the many services and 
products it offers and, with an international resource base, it is important that we 
conduct our business at a level where our actions cannot be questioned. <br></br> <br></br>
We pride ourselves on our reputation for acting fairly and ethically wherever we 
do business, whether at home or abroad. Our reputation is built on our values as 
a company, the values of our employees and our collective commitment to acting 
at all times with integrity. <br></br><br></br>
We condemn corruption in all its forms; we will not tolerate it in our business 
and we expect the same of those with whom we do business. We take a zero tolerance approach to the making or receiving of bribes or corrupt payments in 
any form and will uphold all laws relevant to countering bribery and corruption 
in all the jurisdictions in which we operate.<br></br>
Further to this Statement, the Board of Directors has also approved and put in 
place a comprehensive Anti-Corruption and Bribery Policy.
</p>




<h4 className="About-us pt-2 fs-4 fw-bold ">Anti-Corruption and Bribery Policy</h4>
<p className="text text-justify py-2 P-text">

The Company’s Anti-Corruption & Bribery Policy sets out our responsibilities 
and of those working for us, in observing and upholding our position on bribery 
and corruption and provides information and guidance to those working for us 
on how to recognize and deal with bribery and corruption issues. As a business, 
we refuse to offer, give or receive bribes or any other form of improper payments 
and will not knowingly participate in any form of corrupt activity. 
Appropriate consideration is always given by our employees when offering or 
receiving gifts or hospitality. Any individual who has any questions can speak to 
the Company’s Compliance Officer. The Company will stand by any individual 
in acting ethically. <br></br> <br></br>
The Company expects each of its employees, agents, contractors as well as each 
third party with which it does business to observe and follow the above 
principles and values, and to have operating policies and procedures in place to 
ensure compliance with applicable law(s) when doing business with the 
Compan
</p>





  </Container>
  </div>
    );
}
 
export default Ethics;


